import React from 'react';
import { Cancel, CheckCircle, Error, WatchLater, ReportProblemOutlined, Watch, CalendarToday } from '@material-ui/icons';
import { useGenericStyles } from 'common/genericStyles';
import { Grid, Typography } from '@material-ui/core';
import { OperacaoStatus } from 'common/genericTypes';
import { operacaoStatusDescriptions } from 'common/genericDescriptions';

interface LegendaStatusProps {
  status?: (statusToFilter: string) => void;
}

const LegendaStatus: React.FC<LegendaStatusProps> = ({ status }) => {
  const classes = useGenericStyles();
  
  const handleStatusClick = (statusToFilter: string) => {
    if (status) {
      status(statusToFilter);
    }
  };

  return (
    <Grid container justifyContent="flex-start" spacing={4}>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Concluida')}>
        <CheckCircle fontSize="small" className={classes.successIcon} />
        <Typography display="inline">{'Concluída'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Aguardando Confirmação Custodiante')}>
        <ReportProblemOutlined fontSize="small" />
        <Typography display="inline">{'Aguardando Confirmação'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Em Análise')}>
        <Error fontSize="small" className={classes.waitingIcon} />
        <Typography display="inline">{'Em Análise Laqus'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Aguardando Liquidação')}>
        <WatchLater fontSize="small" className={classes.warningIcon} />
        <Typography display="inline">{'Aguardando Liquidação'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Agendado')}>
        <CalendarToday fontSize="small" />
        <Typography display="inline">{'Agendado'}</Typography>
      </Grid>
      <Grid item style={{ display: 'inline-flex', cursor: status ? 'pointer' : 'default' }} onClick={() => handleStatusClick('Reprovada')}>
        <Cancel fontSize="small" className={classes.errorIcon} />
        <Typography display="inline">{'Cancelada ou Reprovada'}</Typography>
      </Grid>
    </Grid>
  );
};

export default LegendaStatus;
